"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _ShareManager = _interopRequireDefault(require("composer-lib/data/ShareManager"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var shareManager = new _ShareManager.default();

var _default = (0, _createReactClass.default)({
  displayName: "ShareUsers",
  propTypes: {
    compositionId: _propTypes.default.number.isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      emailError: false,
      selected: [],
      sendingEmails: false
    };
  },
  shareByEmail: function shareByEmail(emails) {
    var _this = this;

    shareManager.shareWithEmails({
      compositionId: this.props.compositionId,
      emails: emails
    }).then(function () {
      _this.setState({
        selected: [],
        emailSuccess: true,
        sendingEmails: false
      });
    }, function () {
      _this.setState({
        emailError: true,
        sendingEmails: false
      });
    });
  },
  onSelectChange: function onSelectChange(evt) {
    this.setState({
      selected: evt.target.value || []
    });
  },
  onClickAdd: function onClickAdd() {
    var selectedUserIds = this.state.selected;
    var usersToAdd = this.props.users.data.filter(function (user) {
      return selectedUserIds.includes(user.get('id'));
    });
    (0, _UsageTracking.trackEvent)({
      action: 'share-with-users',
      name: _constants.AmplitudeEvents.COMPOSITION_COLLABORATION,
      what_value: usersToAdd.size
    });
    this.shareByEmail(usersToAdd.map(function (user) {
      return user.get('email');
    }).toArray());
    this.setState({
      sendingEmails: true,
      emailError: false,
      emailSuccess: false
    });
  },
  onClickCancel: function onClickCancel() {
    this.setState({
      selected: []
    });
  },
  renderButtons: function renderButtons() {
    if (this.state.selected.length < 1) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "m-top-3 m-bottom-4"
    }, _react.default.createElement(_UIButton.default, {
      use: "primary",
      onClick: this.onClickAdd
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.shareModal.users.add"
    })), _react.default.createElement(_UIButton.default, {
      use: "secondary",
      onClick: this.onClickCancel
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.shareModal.users.cancel"
    })));
  },
  renderStatus: function renderStatus() {
    if (this.state.emailError) {
      return _react.default.createElement(_UIAlert.default, {
        type: "danger",
        className: "m-top-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "composer-lib.shareModal.users.error"
      }));
    }

    if (this.state.emailSuccess) {
      return _react.default.createElement(_UIAlert.default, {
        type: "success",
        className: "m-top-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "composer-lib.shareModal.users.success"
      }));
    }

    return null;
  },
  render: function render() {
    var userOptions = (0, _userHelpers.packageUserDataForTokens)(this.props.users);
    var _this$state = this.state,
        selected = _this$state.selected,
        sendingEmails = _this$state.sendingEmails;
    var selectProps = {
      disabled: sendingEmails,
      dropdownClassName: 'add-to-share-drop',
      multi: true,
      options: userOptions,
      onChange: this.onSelectChange,
      placeholder: _I18n.default.text('composer-lib.shareModal.users.placeholder')
    }; // Clear UISelect when state reflects nothing is selected

    if (selected.length === 0) {
      selectProps.value = null;
    }

    return _react.default.createElement("div", null, _react.default.createElement(_UIFormControl.default, {
      label: _I18n.default.text('composer-lib.shareModal.users.title')
    }, _react.default.createElement(_UISelect.default, selectProps)), this.renderButtons(), this.renderStatus());
  }
});

exports.default = _default;
module.exports = exports.default;